import React, { useCallback, useMemo, useEffect, useState } from 'react';
import { Portal } from '../../../../hybrid/wrappers';
import PortalFilterGroupForm from '../PortalFilterGroupForm';
import SearchBlockDesctop from '../SearchBlockDesctop';
import SearchBlockMob from '../SearchBlockMob';
import Loader from '../../../plug/Loader/Loader';
import SearchBlockGlobalMob from '../SearchBlockGlobalMob';
import { useRouter } from 'next/router';
import { getFilterForPage, removeFilterForPage } from '../../../../common/utils/utils';
import { useWindowDimensions, useWindowDimensionsSafari } from '../../../../common/utils/windowDimensions';
import classnames from 'classnames';
import { generateCompStylers, getStylePropsFunc } from '../../../../common/utils/styles';
import css from './PortalFilter.module.scss';
import qs from 'qs';

const PortalFilter = ({
    showModal,
    setShowModal,
    pageSettings,
    compStyles,
    screenWidth,
    textsData,
    inputGlobFilter,
    globalSearchFunc = async () => {},
    filter,
    sort,
    grid,
    dataFiltersToUrl,
    dataFiltersItemsCountToUrl,
    setGridData,
    fullWidth,
    convertData,
    convertHeadData,
    setUrl,
    token,
    showFiler = false,
    translates
}) => {
    //filter.setFilterFields => передача обєкту коли вибирається щось в полях
    //filter.setFilterValue => передача обєкту після застосування фільтру або скиду
    const router = useRouter();
    const componentStyles = { ...css, ...compStyles };
    const { stylers, classes } = generateCompStylers(componentStyles);
    const getStyleProps = (...keys) => getStylePropsFunc(componentStyles, ...keys);

    const [showFilerForm, setShowFilterForm] = useState(showFiler);
    const emptyFilterData = filter?.data({});
    const [formData, setFormData] = useState(
        Object.keys(emptyFilterData).reduce((acc, curr) => {
            emptyFilterData[curr]?.fields?.forEach((field) => {
                if (field?.default_value) {
                    acc[field?.attribute] = field?.default_value;
                }
            });
            return acc;
        }, {})
    );
    const widthDimensions = useWindowDimensionsSafari();

    useEffect(() => {
        if (filter?.saveFilterParams) {
            const localParams = getFilterForPage(router?.route);
            const parsedParams = qs.parse(localParams);

            const newFormData = Object.keys(emptyFilterData).reduce((acc, curr) => {
                emptyFilterData[curr]?.fields?.forEach((field) => {
                    if (field.type === 'range-date-widget') {
                        if (parsedParams?.['filter']?.[field.attribute + '_after']) {
                            acc[field.attribute] = {
                                start: parsedParams?.['filter']?.[field.attribute + '_after'],
                                end: parsedParams?.['filter']?.[field.attribute + '_before']
                            };
                        }
                    }
                    if (field.type === 'range-values') {
                        if (field?.options) {
                            field?.options?.map((opt) => {
                                if (parsedParams?.['filter']?.[opt]) {
                                    acc[opt] = parsedParams?.['filter'][opt];
                                }
                            });
                        }
                    }
                    if (parsedParams?.['filter']?.[field.attribute]) {
                        acc[field?.attribute] = parsedParams?.['filter']?.[field.attribute];
                    }
                });
                return acc;
            }, {});
            setFormData(newFormData);
        }
    }, [filter?.saveFilterParams, router?.route]);

    const mobile = useMemo(() => widthDimensions < 992, [widthDimensions]);

    const [windowWidth, setWindowWidth] = useState('');
    const windowDimensions = useWindowDimensions();
    const [loading, setShowLoading] = useState(false);
    useEffect(() => {
        windowDimensions < 1185 ? setWindowWidth(true) : setWindowWidth(false);
    }, [windowDimensions]);
    useEffect(() => {
        if (typeof filter?.setFilterFields == 'function') {
            filter.setFilterFields(formData);
        }
    }, [formData]);
    useEffect(() => {
        windowDimensions < 1185 ? setWindowWidth(true) : setWindowWidth(false);
    }, [windowDimensions]);
    const resetFilter = useCallback(
        async (customSearcher) => {
            if (typeof filter?.setFilterValue == 'function') {
                filter.setFilterValue(false);
            }
            filter?.setFormDataMain && filter?.setFormDataMain({});
            setShowLoading(true);
            if (dataFiltersToUrl?.hasOwnProperty('current')) {
                dataFiltersToUrl.current = '';
            } else if (dataFiltersItemsCountToUrl?.hasOwnProperty('current')) {
                dataFiltersItemsCountToUrl.current = '';
            }
            setFormData({});
            setShowModal(false);
            setShowFilterForm(false);
            removeFilterForPage(router?.route);
            if (customSearcher && typeof customSearcher === 'function') {
                await customSearcher();
            } else {
                await globalSearchFunc('');
            }
            setShowLoading(false);
            if (filter?.showDataOnlyWithFilter) {
                setGridData((pre) => ({
                    ...pre,
                    tbody: []
                }));
            }
        },
        [dataFiltersItemsCountToUrl, dataFiltersToUrl, filter, globalSearchFunc, setShowModal, router]
    );
    const closeModal = () => {
        setShowLoading(false);
        setShowModal(false);
        setShowFilterForm(false);
    };

    if (!showModal) return null;
    return (
        <Portal
            closeHandler={closeModal}
            fullHeight={!showFilerForm && !pageSettings?.hideSearchInput}
            customClass={!screenWidth ? 'modalTop' : 'modalBottom'}
            fullWidth={fullWidth || windowWidth}
        >
            <div
                {...(!mobile ? { 'data-scroll': true } : {})}
                style={{
                    ...stylers.adminFilterWindowWrapper,
                    ...stylers.adminFilterWindowWrapperWebFull,
                    ...(screenWidth && !showFilerForm && !pageSettings?.hideSearchInput
                        ? stylers.adminFilterWindowWrapperGlobalSearchMob
                        : {})
                }}
                className={classnames(
                    classes.adminFilterWindowWrapper,
                    classes.adminFilterWindowWrapperWebFull,
                    screenWidth && !showFilerForm && !pageSettings?.hideSearchInput
                        ? classes.adminFilterWindowWrapperGlobalSearchMob
                        : ''
                )}
            >
                {!showFilerForm && !pageSettings?.hideSearchInput && !!screenWidth && (
                    <div {...getStyleProps('adminFilterDivSearch')}>
                        <SearchBlockGlobalMob compStyles={componentStyles} textsData={textsData} closeModal={closeModal} />
                        <SearchBlockDesctop
                            pageSettings={pageSettings}
                            closeModal={closeModal}
                            compStyles={componentStyles}
                            inputGlobFilter={inputGlobFilter}
                            globalSearchFunc={globalSearchFunc}
                            textsData={textsData}
                            setShowFilterForm={setShowFilterForm}
                            translates={translates}
                        />
                    </div>
                )}
                {(showFilerForm || !screenWidth || pageSettings?.hideSearchInput) && (
                    <div {...getStyleProps('adminFilterDivSearch')}>
                        <SearchBlockMob
                            compStyles={componentStyles}
                            showFilerForm={showFilerForm}
                            screenWidth={screenWidth}
                            textsData={textsData}
                            closeModal={closeModal}
                            translates={translates}
                        />
                        {loading ? (
                            <Loader />
                        ) : (
                            <PortalFilterGroupForm
                                formData={formData}
                                setFormData={setFormData}
                                inputGlobFilter={inputGlobFilter}
                                setShowLoading={setShowLoading}
                                setShowModal={setShowModal}
                                compStyles={componentStyles}
                                dataFiltersToUrl={dataFiltersToUrl}
                                dataFiltersItemsCountToUrl={dataFiltersItemsCountToUrl}
                                setGridData={setGridData}
                                filter={filter}
                                grid={grid}
                                textsData={textsData}
                                convertData={convertData}
                                convertHeadData={convertHeadData}
                                setUrl={setUrl}
                                sort={sort}
                                token={token}
                                resetFilter={resetFilter}
                            />
                        )}
                    </div>
                )}
            </div>
        </Portal>
    );
};
export default PortalFilter;
